import './Drawer.css';
export var DrawerBackdropCSS = '_12pg2yu7-2-0-1';
export var DrawerCSS = '_12pg2yu0-2-0-1';
export var DrawerContentCSS = '_12pg2yu8-2-0-1';
export var DrawerPlacementCSS = {left:'_12pg2yu1-2-0-1',right:'_12pg2yu2-2-0-1'};
export var DrawerWidthStyles = {narrow:'_12pg2yu3-2-0-1',medium:'_12pg2yu4-2-0-1',wide:'_12pg2yu5-2-0-1',full:'_12pg2yu6-2-0-1'};